import React from "react";
import { IAdHocProject, IAsset, IProject } from "../../../../models/applicationState";
import { Checkbox, FontIcon } from "@fluentui/react";
import { ContentSource } from "../../common/assetPreview/assetPreview";
import { AssetPreview } from "./assetPreview";

export interface IEditorSideBarItemProps {
    asset?: IAsset;
    style: any;
    getAssetCssClassNames: (asset: IAsset, selectedAsset?: IAsset) => string;
    selectedAsset?: IAsset;
    onAssetClicked: (asset: IAsset) => void;
    deleteAssetOnSelect: (event, asset: IAsset) => void;
    download: (url, name, event) => void;
    checkboxRowRenderer?: (asset: IAsset) => JSX.Element;
    renderBadges: (asset: IAsset) => JSX.Element;
    onAssetLoaded?: (asset: IAsset, ContentSource: ContentSource) => void;
    assetTitle?: string;
    projectId: string;
    adHocProject: IAdHocProject;
    loadAdHocOcrProject: (requestId: string) => Promise<void>;
    selectedRequestId?: string;
    hasModel?: boolean;
    hasRunningRequest?: boolean;
    isGenerateModelChecked?: boolean;
    onGenerateModelChanged: (key: string, val: string) => void;
}

export interface IEditorSideBarItemState {
    isVisible: boolean
}

export default class EditorSideBarItem extends React.Component<IEditorSideBarItemProps, IEditorSideBarItemState> {
    private panelRef: React.RefObject<any> = React.createRef();
    constructor(props: IEditorSideBarItemProps) {
        super(props);

        this.state = {
            isVisible: true
        };
        this.initializeIntersectionObserver = this.initializeIntersectionObserver.bind(this);
    }

    componentDidMount() {
        //this.initializeIntersectionObserver();
    }

    initializeIntersectionObserver() {
        if (!('IntersectionObserver' in window)) {
            //console.error('IntersectionObserver not supported');
        }

        const intersectionObserver = new IntersectionObserver(
            (entries: IntersectionObserverEntry[], observer: IntersectionObserver) => {
                entries.forEach((entry, i) => {
                    if (!entry.isIntersecting) return;

                    observer.unobserve(entry.target);

                    this.setState({
                        isVisible: true,
                    });
                });
            }
        );

        intersectionObserver.observe(this.panelRef.current);
    }

    public render() {
        const { style, getAssetCssClassNames, selectedAsset, onAssetClicked, deleteAssetOnSelect, download, checkboxRowRenderer, renderBadges, onAssetLoaded, assetTitle } = this.props;
        const asset = Object.values(this.props.adHocProject.project.assets)[0];
        let cssName = this.props.adHocProject.project.id === this.props.selectedRequestId ? 'asset-item-image-selected' : 'asset-item-image';
        const isSelected = this.props.adHocProject.project.id === this.props.selectedRequestId;
        return (            
            <div
                ref={this.panelRef}
                key={this.props.adHocProject.project.id}
                style={{
                    padding: "15px",
                    marginBottom: "10px",
                    border: isSelected ? "2px solid #0078d4" : "2px solid #cce7ff", // Blue border for selected and light blue for unselected
                    borderRadius: "8px", // Rounded corners for a modern look
                    backgroundColor: isSelected ? "#e6f7ff" : "#f4faff", // Light blue background for selected and lighter blue for unselected
                    boxShadow: isSelected
                        ? "0 4px 8px rgba(0, 120, 212, 0.2)" // Subtle shadow for selected item
                        : "0 4px 8px rgba(0, 0, 0, 0.1)", // Default shadow for unselected items
                    transition: "all 0.2s ease-in-out", // Smooth transition for hover and selection effects
                    cursor: "pointer" // Pointer cursor to indicate clickability
                }}
                role="row"
                //className={getAssetCssClassNames(asset, selectedAsset)}
                // onClick={() => this.props.loadAdHocOcrProject(this.props.adHocProject.project.id)}
            >
                {this.props && this.props.adHocProject &&
                    <React.Fragment>
                        <Checkbox
                            label="Generate Model"
                            //onChange={this.onSplitMultiplePageFilesCheckChanged}
                            checked={this.props.isGenerateModelChecked}
                            style={{
                                position: "absolute",
                                bottom: "10px",
                                right: "10px",
                                zIndex: 10,
                                color: isSelected ? "#0078d4" : "#333", // Blue text for selected, dark gray for unselected
                                fontSize: "12px", // Slightly larger font for better visibility
                            }}
                            className="ms-Checkbox-checkbox2"
                            onChange={() => this.props.onGenerateModelChanged(this.props.adHocProject.vendor, this.props.adHocProject.project.id)}
                            name="generate-model"
                        />
                        <div 
                            className={isSelected ? "asset-item-image-selected" : "asset-item-image"}
                            role="gridcell"
                            onClick={() => this.props.loadAdHocOcrProject(this.props.adHocProject.project.id)}
                            style={{                                
                                backgroundColor: isSelected ? "#0078d4" : "#cce7ff", // Blue background for selected and light blue for unselected
                                color: isSelected ? "#ffffff" : "#004578", // White text for selected, dark blue for unselected
                                //padding: "10px",
                                borderRadius: "5px", // Rounded corners for the asset preview
                                textAlign: "center",
                                //fontWeight: isSelected ? "bold" : "normal", // Bold text for selected item
                                transition: "all 0.2s ease-in-out", // Smooth transition for hover and selection effects
                            }}
                        >                            
                            <AssetPreview
                                project={this.props.adHocProject.project}
                            />
                        </div>
                        <div className="asset-item-metadata" role="rowheader" onClick={() => this.props.loadAdHocOcrProject(this.props.adHocProject.project.id)}>
                            <span className="asset-filename" title="123">
                                {asset.name}
                            </span>                            
                        </div>
                    </React.Fragment>
                }
            </div>
        );
    }
}
